var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"uk-container uk-background-primary"},[(false)?_c('waiting',{attrs:{"closedText":"Der Rodeo LIVE Chat wird gerade für dich vorbereitet."}}):_vm._e(),_c('div',{staticClass:"chat-component-wrapper"},[_c('chat-component')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }